import React from "react";
import { Navigate } from "react-router-dom";
import { useRoleCheck } from "../Components/Hooks/useRoleCheck";
import { useProfile } from "../Components/Hooks/UserHooks";

/**
 * Component to protect routes based on user roles
 * Usage: <RoleProtectedRoute requiredRoles={["User", "Admin"]} component={<Component />} />
 */
const RoleProtectedRoute = ({ component: Component, requiredRoles, fallbackPath = "/dashboard" }) => {
  const { hasAccess } = useRoleCheck(requiredRoles);
  const { loading } = useProfile();

  // Show nothing while loading
  if (loading) {
    return <div>Loading...</div>;
  }

  // If user doesn't have required role, redirect to fallback path
  if (!hasAccess) {
    return <Navigate to={fallbackPath} replace />;
  }

  return Component;
};

export { RoleProtectedRoute };
